import { IMenuState } from './state';
import { actions } from "./actions";
import { getters } from "./getters";
import { mutations} from "./mutations";


export const defaultState: IMenuState = {
    menu: null,
    categories: [],
    items: [],
    counter: null,
};

export const menuModule = {
    state: defaultState,
    mutations,
    actions,
    getters
};